
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"16.057","viewBox":"0 0 17.902 16.057"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.02 11.369l6.515-6.515a.661.661 0 01.932 0l1.579 1.58a.661.661 0 010 .932l-7.465 7.465a1.984 1.984 0 01-2.8 0l-1.554-1.554a1.984 1.984 0 010-2.8l8.131-8.131c1.2-1.2 1.742-1.671 2.649-1.671l3.744-.178a1.653 1.653 0 011.648 1.648l-.178 3.745c0 .906-.468 1.424-1.677 2.634l-7.177 7.177","fill":"none","stroke":"#007d57","stroke-miterlimit":"10"}})])
          )
        }
      }
    